<template>
  <v-container grid-list-xl fluid>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-title>
            <search-field ref="searchRef" @search="search"></search-field>
            <v-spacer></v-spacer>

            <!-- Refresh Button -->
            <!-- <refresh-button @refresh="refreshTable()"></refresh-button> -->

            <!-- v-if="$moduleAccess('add_role')" -->
            <add-button v-if="$moduleAccess('add_role')" @add="openAddDialog"></add-button>
            <!-- <multi-assign-button
              title="Roles Assigment"
              @assign="openMultiAssignDialog"
            ></multi-assign-button>-->

            <action-dialog
              :type="dialogType"
              :title="title"
              :dialog="dialogStatus"
              @saveDialog="saveDialog"
              @closeDialog="closeDialog"
              :loading="dialogLoading"
            >
              <v-container grid-list-xs>
                <v-layout justify-center>
                  <v-flex md6>
                    <details-container
                      ref="detailsRef"
                      :data="viewData"
                      :readonly="dialogType === 'view'"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </action-dialog>

            <v-dialog v-model="moduleDialog" max-width="500px">
              <v-card>
                <v-card-title>
                  <span class="headline">Select Module</span>
                </v-card-title>

                <v-card-text>
                  <v-data-table
                    v-model="menuItem.modules"
                    item-key="id"
                    :headers="moduleHeaders"
                    :items="moduleItems"
                    select-all
                    hide-actions
                    disable-initial-sort
                  >
                    <template slot="headers" slot-scope="props">
                      <tr>
                        <th>
                          <v-checkbox
                            class="ml-5"
                            :input-value="props.all"
                            :indeterminate="props.indeterminate"
                            color="primary"
                            hide-details
                            @click.stop="toggleAllMenu"
                          ></v-checkbox>
                        </th>

                        <th
                          v-for="header in props.headers"
                          :key="header.text"
                          :class="[
                                'column sortable',
                                header.value === queryParams.order
                                  ? 'active'
                                  : '',
                                'text-xs-' + header.align
                              ]"
                        >{{ header.text }}</th>
                      </tr>
                    </template>
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-center">
                        <v-checkbox
                          class="ml-5"
                          color="primary"
                          v-model="props.selected"
                          hide-details
                        ></v-checkbox>
                      </td>
                      <td class="text-xs-left text-uppercase">{{ props.item.name }}</td>
                      <td class="text-xs-left">{{ props.item.code }}</td>
                    </template>
                  </v-data-table>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" flat @click="closeMenu">Cancel</v-btn>
                  <v-btn color="blue darken-1" flat @click="saveMenu">Ok</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <action-dialog
              :type="dialogType"
              :disableSave="selected.length < 1"
              :title="title"
              :dialog="multiAssignDialog"
              @saveDialog="multiSaveDialog"
              @closeDialog="closeDialog"
              :loading="dialogLoading"
            >
              <v-container grid-list-xs>
                <v-layout justify-center>
                  <v-flex md5>
                    <details-container
                      ref="detailsRef"
                      :data="viewData"
                      :readonly="dialogType === 'view'"
                    />
                  </v-flex>
                  <v-flex md7>
                    <jti-expansion-panel panelName="Module Settings">
                      <!-- <v-form v-model="valid" ref="form" lazy-validation> -->
                      <v-data-table
                        v-model="selected"
                        item-key="id"
                        :headers="pagesHeaders"
                        :items="pageItems"
                        select-all
                        hide-actions
                        disable-initial-sort
                      >
                        <template slot="headers" slot-scope="props">
                          <tr>
                            <th>
                              <v-checkbox
                                class="ml-5"
                                :input-value="props.all"
                                :indeterminate="props.indeterminate"
                                color="primary"
                                hide-details
                                @click.stop="toggleAll"
                              ></v-checkbox>
                            </th>

                            <th
                              v-for="header in props.headers"
                              :key="header.text"
                              :class="[
                                'column sortable',
                                header.value === queryParams.order
                                  ? 'active'
                                  : '',
                                'text-xs-' + header.align
                              ]"
                            >{{ header.text }}</th>
                          </tr>
                        </template>
                        <template slot="items" slot-scope="props">
                          <td class="text-xs-center">
                            <v-checkbox
                              class="ml-5"
                              color="primary"
                              v-model="props.selected"
                              hide-details
                              :readonly="dialogType==='view'"
                            ></v-checkbox>
                          </td>
                          <td class="text-xs-left text-uppercase">{{ props.item.name }}</td>
                          <td class="text-xs-left">{{ props.item.link }}</td>

                          <td class="test-xs-center text-no-wrap">
                            <div v-if="dialogType === 'view'">
                              <v-chip
                                v-for="(mode, index) in viewMenu(props.item.id)"
                                :key="index"
                                color="grey darken-1"
                                text-color="white"
                              >{{mode.name}}</v-chip>
                            </div>
                            <module-button
                              v-else
                              :disabled="!props.selected"
                              @module="openMenuDialog(props.item)"
                            ></module-button>
                          </td>
                        </template>
                      </v-data-table>
                      <!-- </v-form> -->
                    </jti-expansion-panel>
                  </v-flex>
                </v-layout>
              </v-container>
            </action-dialog>

            <delete-dialog
              :title="title"
              :type="deleteType"
              :deleteDialog="deleteDialog"
              @saveDeleteDialog="saveDeleteDialog"
              @closeDeleteDialog="closeDeleteDialog"
              :loading="confirmLoading"
            ></delete-dialog>

            <confirm-dialog
              :confirmDialog="openConfirmDialog"
              @saveConfirmDialog="
                dialogType === 'edit'
                  ? saveEditDialog()
                  : dialogType === 'add'
                  ? saveConfirmedAddDialog()
                  : ''
              "
              @closeConfirmDialog="closeConfirmDialog"
              :loading="confirmLoading"
            ></confirm-dialog>
          </v-card-title>
          <v-divider></v-divider>

          <v-container fluid class="pa-2">
            <v-layout row>
              <v-flex sm4 md4>
                <!-- <v-btn flat @click="openFilterExpansion">
                  <v-icon class="mr-3">
                    {{
                    openFilter ? "keyboard_arrow_up" : "keyboard_arrow_down"
                    }}
                  </v-icon>
                  <span>Filter {{ title }}</span>
                </v-btn>-->
              </v-flex>
              <v-flex sm8 md8>
                <v-container class="py-2 pr-0" fluid>
                  <v-layout row align-center>
                    <v-flex xs12 sm8 md9 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm10 md11 class="px-0">
                          <p
                            class="text-xs-right grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >Row per Page:</p>
                        </v-flex>
                        <v-flex xs6 sm2 md1 class="text-xs-center">
                          <v-layout row align-center>
                            <v-flex xs7 sm12>
                              <v-select
                                style="font-size: 14px;"
                                :items="page"
                                class="grey--text"
                                id="selected"
                                v-model="pageLimit"
                                @input="limitClick"
                                dense
                                height="20px"
                                :disabled="
                                  this.items.length < 10 ? true : false
                                "
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm4 md3 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm6 class="px-0 pl-3">
                          <p
                            class="text-xs-center grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >
                            {{ itemFrom + " -" + itemTo + " of " }}
                            {{ totalItems }}
                          </p>
                        </v-flex>
                        <v-flex xs6 sm6>
                          <v-layout row style="padding-right: 100px;">
                            <v-flex sm6 class="mr-3 pl-0">
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="backClick"
                                :disabled="disabledBack"
                              >
                                <v-icon dark>chevron_left</v-icon>
                              </v-btn>
                            </v-flex>
                            <v-flex sm6>
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="nextClick"
                                :disabled="disabledNext"
                              >
                                <v-icon dark>chevron_right</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <filter-panel :openFilter="openFilter">
            <v-flex md4>
              <v-select
                v-model="filterStatus"
                :items="filterStatuses"
                label="Status"
                solo
                clearable
              ></v-select>
            </v-flex>
          </filter-panel>

          <v-data-table :headers="headers" :items="items" hide-actions disable-initial-sort>
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    header.value === queryParams.order ? 'active' : '',
                    'text-xs-' + header.align
                  ]"
                  @click="header.sortable ? changeSort(header) : ''"
                >
                  {{ header.text.toUpperCase() }}
                  <v-icon small v-if="header.sortable">
                    {{
                    header.sortNum === 1 ? "arrow_downward" : "arrow_upward"
                    }}
                  </v-icon>
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">{{ props.index + queryParams.offset + 1 }}</td>
              <td class="text-xs-left text-uppercase">{{ props.item.name }}</td>

              <td class="text-no-wrap text-xs-center">
                <view-button @view="openViewDialog(props.item)"></view-button>

                <edit-button v-if="$moduleAccess('edit_role')" @edit="openEditDialog(props.item)"></edit-button>

                <delete-button
                  v-if="$moduleAccess('delete_role')"
                  @delete="openDeleteDialog(props.item)"
                ></delete-button>
              </td>
            </template>
          </v-data-table>
          <v-divider></v-divider>
          <v-container class="py-0" fluid>
            <v-layout wrap align-center class="pa-5"></v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Services from "@/services/SubCompanyServices";
import DetailsContainer from "@/components/details_container/RoleDetailsContainer";

export default {
  components: {
    DetailsContainer
  },
  data() {
    return {
      moduleItems: [],
      selected: [],

      pagesHeaders: [
        {
          text: "Page Name",
          align: "left",
          value: "name",
          sortable: true
        },
        {
          text: "Link",
          align: "left",
          value: "name",
          sortable: false
        },
        {
          text: "Module",
          align: "center",
          value: "name",
          sortable: true
        }
      ],
      moduleHeaders: [
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: true
        },
        {
          text: "Code",
          align: "left",
          value: "name",
          sortable: false
        }
      ],
      multiAssignDialog: false,
      pageItems: [],
      openFilter: false,
      title: "Role",
      headers: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: true
        },
        {
          text: "Action",
          align: "center",
          sortable: false
        }
      ],
      items: [],
      searchData: "",
      queryParams: {
        search: "",
        limit: 10,
        offset: 0,
        order: "",
        desc: false,
        company_id: null,
        sub_company_id: null
      },
      dialogType: "",
      dialogStatus: false,
      openConfirmDialog: false,
      viewData: {},

      deleteDialog: false,
      deleteTitle: "",
      deleteType: "",

      confirmLoading: false,
      dialogLoading: false,

      totalItems: 0,
      itemFrom: 0,
      itemTo: 0,
      disabledNext: false,
      disabledBack: true,
      page: [
        { text: 10, value: 10 },
        { text: 20, value: 20 },
        { text: 30, value: 30 },
        { text: 40, value: 40 },
        { text: 50, value: 50 }
      ],
      companies: [],
      filterCompanies: [],
      filterCompany: null,
      filterStatuses: [
        {
          text: "ASSIGNED",
          value: "true"
        },
        {
          text: "UNASSIGNED",
          value: "false"
        }
      ],
      filterStatus: null,

      moduleDialog: false,
      menuItem: {},
      menuIndex: -1
    };
  },
  created: function() {
    this.getData();
  },
  computed: {
    pageLimit: {
      get() {
        return 10;
      },
      set(val) {
        this.queryParams.limit = val;
        this.queryParams.offset = 0;
      }
    }
  },
  watch: {
    filterCompany: async function() {
      if (
        this.filterCompany !== null &&
        this.filterCompany !== undefined &&
        this.filterCompany !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.company_id = this.filterCompany;
        this.getData();
      } else {
        this.queryParams.offset = 0;
        this.queryParams.company_id = null;
        this.getData();
      }
    },
    filterStatus: async function() {
      if (
        this.filterStatus !== null &&
        this.filterStatus !== undefined &&
        this.filterStatus !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.is_assigned = this.filterStatus;
        this.getData();
      } else {
        this.queryParams.offset = 0;
        this.queryParams.is_assigned = null;
        this.getData();
      }
    }
  },
  methods: {
    search(data) {
      this.queryParams.search = data;
      this.queryParams.offset = 0;
      this.queryParams.limit = 10;
      this.getData();
    },
    async getData() {
      // Start Loading
      this.$clearInfoBar();
      this.items = [];
      this.$store.dispatch("startLoading");

      this.queryParams.company_id = this.$store.state.company.id;
      this.queryParams.sub_company_id = this.$store.state.subcompany.id;

      try {
        // Query Data
        let response = (await Services.getRoles(this.queryParams)).data;

        // Assign the reponse data to items to be display on table
        this.items = response.data;

        // Assign Total number of data
        this.totalItems = response.count;

        // Assign Number started the data
        this.itemFrom = this.totalItems > 0 ? this.queryParams.offset + 1 : 0;

        // Assign Number end the data
        this.itemTo = this.queryParams.offset + this.queryParams.limit;

        if (this.totalItems <= this.itemTo) {
          this.itemTo = this.totalItems;
        }

        // Conditions for NextPage Button
        if (this.itemTo === this.totalItems) {
          this.disabledNext = true;
        } else {
          this.disabledNext = false;
        }
        // Conditions for BackPage Button
        if (this.itemFrom > 1) {
          this.disabledBack = false;
        } else {
          this.disabledBack = true;
        }
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection"
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          } else {
            this.$infoBar({
              type: "error",
              text: "No network or server connection"
            });
          }
        }
      }
      this.$store.dispatch("endLoading");
    },
    async setData(id) {
      var data = {};

      try {
        const response = await Services.getRole(id);
        data = await response.data;
        data.name = data.name ? data.name.toUpperCase() : "";
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        } else {
          if (error.response.status === 403) {
            this.closeDialog();
            this.$store.dispatch("dispatchUnauthorized", true);
          } else {
            this.$infoBar({
              type: "error",
              text: "No network or server connection"
            });
          }
        }
      }
      return data;
    },
    async setCompanies() {
      this.companies = [];
      const items = (await Services.getCompanies({})).data;
      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id
        };
        this.companies.push(data);
      }
    },
    async setFilterCompanies() {
      this.filterCompanies = [];
      const items = (await Services.getCompanies({})).data;

      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id
        };
        this.filterCompanies.push(data);
      }

      this.filterCompanies.push({
        text: "UNASSIGNED",
        value: "isNull"
      });
    },
    async changeSort(column) {
      this.queryParams.offset = 0;
      if (this.queryParams.order === column.value) {
        column.sortNum++;
        if (column.sortNum === 1) {
          this.queryParams.desc = true;
        }
        if (column.sortNum === 2) {
          column.sortNum = 0;
          this.queryParams.desc = false;
          this.queryParams.order = "";
        }
      } else {
        this.queryParams.order = column.value;
        this.queryParams.desc = false;
        column.sortNum = 0;
      }
      for (let i = 0; i < this.headers.length; i++) {
        if (this.headers[i].value === column.value) {
          this.headers[i].sortNum = column.sortNum;
        }
      }
      this.getData();
    },
    nextClick() {
      this.queryParams.offset += this.queryParams.limit;
      this.getData();
    },
    backClick() {
      this.queryParams.offset -= this.queryParams.limit;
      this.getData();
    },
    async limitClick() {
      this.queryParams.offset = 0;
      this.getData();
    },
    multiCloseDialog() {
      this.dialogType = "";
      this.selected = [];
      this.assignCompany = "";
      this.multiAssignDialog = false;
      this.closeConfirmDialog();
    },
    multiSaveDialog() {
      if (this.$refs.detailsRef.validateForm()) {
        this.openConfirmDialog = true;
      }
    },

    async setPages() {
      // Query Pages
      let response = (await Services.getPages({})).data;

      // Asign response to pageItems []
      this.pageItems = response.data.map(item => {
        return {
          id: item.id,
          name: item.name,
          link: item.link,
          modules: []
        };
      });
    },
    async openAddDialog() {
      this.dialogLoading = true;
      this.selected = [];
      this.dialogType = "add";
      this.multiAssignDialog = true;
      this.setPages();
      this.setModules();

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openViewDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "view";
      this.multiAssignDialog = true;

      this.viewData = await this.setData(data.id);

      this.selected = this.viewData.menu;

      await this.setPages();
      await this.setModules();

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openEditDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "edit";
      this.multiAssignDialog = true;

      this.viewData = await this.setData(data.id);

      // this.selected = this.viewData.menu;

      await this.setPages();

      await this.setModules();

      this.pageItems.map(async item => {
        const page = await this.viewData.menu.find(elem => elem.id === item.id);

        if (page) {
          console.log(page);

          let mods = [];

          page.modules.map(async mod => {
            const findModule = this.moduleItems.find(dat => dat.id === mod.id);
            if (findModule) {
              mods.push(findModule);
            }
          });

          this.selected.push({
            id: page.id,
            name: page.name,
            link: page.link,
            modules: mods
          });
        }
      });

      // console.log(this.selected.find(mod => mod.id === ));

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openDeleteDialog(data) {
      this.deleteDialog = true;
      this.viewData.id = data.id;
    },
    saveDialog() {
      // Condition Form Required Form Validation
      if (this.$refs.detailsRef.validateForm()) {
        this.openConfirmDialog = true;
      }
      if (this.dialogType === "upload") this.openConfirmDialog = true;
    },
    saveUpDialog() {
      // Condition Form Required Form Validation
      this.openConfirmDialog = true;
    },
    async saveConfirmedAddDialog() {
      // console.log("test");
      this.confirmLoading = true;

      const data = this.$refs.detailsRef.computedData;

      const menu = this.selected.map(menuItem => {
        let modules = [];
        if (menuItem.modules) {
          if (menuItem.modules.length) {
            modules = menuItem.modules.map(mod => {
              return { id: mod.id };
            });
          }
        }

        return {
          id: menuItem.id,
          modules
        };
      });

      const body = {
        name: data.name,
        sub_company_id: this.$store.state.subcompany.id,
        menu
      };

      try {
        const response = await Services.addRole(body);
        if (
          response.status === 200 ||
          response.status === 201 ||
          response.status === 204
        ) {
          this.closeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Role(s) has been added"
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!"
          });
        }
      } catch (error) {
        this.closeConfirmDialog();
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        } else {
          if (error.response.status === 403) {
            this.closeDialog();

            this.$store.dispatch("dispatchUnauthorized", true);
          } else if (error.response.status === 422) {
            this.$infoBar({
              type: "error",
              text: `${this.$capitalizeFirstLetter(
                error.response.data.message
              )} `
            });
          } else {
            this.$infoBar({
              type: "error",
              text: "No network or server connection"
            });
          }
        }
      }

      this.confirmLoading = await false;
    },
    async saveEditDialog() {
      this.confirmLoading = true;

      const data = this.$refs.detailsRef.computedData;

      const menu = this.selected.map(menuItem => {
        let modules = [];
        if (menuItem.modules) {
          if (menuItem.modules.length) {
            modules = menuItem.modules.map(mod => {
              return { id: mod.id };
            });
          }
        }

        return {
          id: menuItem.id,
          modules
        };
      });

      const body = {
        name: data.name,
        menu
      };

      try {
        console.log(data.id);
        console.log(body);

        const response = await Services.editRole(data.id, body);

        if (
          response.status === 200 ||
          response.status === 201 ||
          response.status === 204
        ) {
          this.closeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Role has been updated!"
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!"
          });
        }
      } catch (error) {
        this.closeConfirmDialog();
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        } else {
          if (error.response.status === 403) {
            this.closeDialog();
            this.$store.dispatch("dispatchUnauthorized", true);
          } else if (error.response.status === 422) {
            this.$infoBar({
              type: "error",
              text: `${this.$capitalizeFirstLetter(
                error.response.data.message
              )} `
            });
          } else {
            this.$infoBar({
              type: "error",
              text: "No network or server connection"
            });
          }
        }
      }

      this.confirmLoading = await false;
    },
    async saveDeleteDialog() {
      this.confirmLoading = true;

      try {
        const response = await Services.deleteRole(this.viewData.id);
        if (response.status === 200 || response.status === 201) {
          this.closeDeleteDialog();
          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Role has been deleted!"
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!"
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        } else {
          if (error.response.status === 403) {
            this.closeDeleteDialog();
            this.$store.dispatch("dispatchUnauthorized", true);
          } else {
            this.$infoBar({
              type: "error",
              text: "No network or server connection"
            });
          }
        }
      }
      this.confirmLoading = false;
    },
    async closeDialog() {
      this.viewData = {};
      this.pageItems = [];

      this.selected = [];

      if (this.dialogLoading === false) {
        this.$refs.detailsRef.clear();
      }

      this.closeMenu();

      this.closeConfirmDialog();
      this.dialogType = "";
      this.multiAssignDialog = false;
    },
    closeConfirmDialog() {
      this.openConfirmDialog = false;
    },
    async closeDeleteDialog() {
      this.deleteDialog = false;
    },
    async openFilterExpansion() {
      this.openFilter = await !this.openFilter;
      await this.setFilterCompanies();
    },
    async refreshTable() {
      this.$refs.searchRef.clear();
      this.filterCompany = null;
      this.filterStatus = null;

      this.getData();
    },

    async setModules(id) {
      // Query data
      const response = (await Services.getModules({ page_id: id })).data;

      this.moduleItems = response.data.map(item => {
        return {
          id: item.id,
          code: item.code,
          name: item.name
        };
      });
    },

    async openMenuDialog(data) {
      this.menuIndex = this.pageItems.indexOf(data);

      this.menuItem = await Object.assign({}, data);

      const findPage = await this.selected.find(item => item.id === data.id);

      if (findPage) {
        this.menuItem.modules = findPage.modules;
      }

      this.moduleDialog = true;

      await this.setModules(data.id);
    },
    closeMenu() {
      this.moduleDialog = false;
      setTimeout(() => {
        this.menuItem = {};
        this.menuIndex = -1;
      }, 300);
    },

    async saveMenu() {
      const index = await this.selected.findIndex(
        item => item.id === this.menuItem.id
      );

      Object.assign(this.selected[index], this.menuItem);

      this.closeMenu();
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.pageItems.slice();
    },
    toggleAllMenu() {
      if (this.menuItem.modules.length) this.menuItem.modules = [];
      else this.menuItem.modules = this.moduleItems.slice();
    },
    viewMenu(id) {
      let data = [];
      const find = this.selected.find(item => item.id === id);

      if (find) {
        return find.modules;
      }

      return data;
    }
  }
};
</script>

<style scoped>
.scrolling-wrapper {
  overflow-x: hidden;
  width: 400px;
  height: 400px;
  overflow-y: scroll;
  white-space: nowrap;
}
</style>
